<div *ngIf="show" @fadeInOut class="absolute bottom-[5%] left-0 right-0 z-50">
  <div class="flex items-center gap-2 bg-[#242a42] w-[80%] md:w-[25%] px-4 py-3 rounded-[12px] mx-auto">
    <img src="/assets/svgs/info-circle.svg" alt="texto informativo">
    <span class="toast-message text-white">{{ message }}</span>
  </div>
</div>